<template>
  <div class="container mb-20 mx-auto">
    <div class="p-4 bg-white rounded-xl md:p-12 lg:p-20">
      <h3 v-if="title" class="mb-4 text-3xl font-black uppercase">{{ title }}</h3>
      <div class="md:grid md:gap-12 md:grid-cols-2 md:grid-rows-1 lg:gap-24">
        <div class="row-auto bg-white">
          <MoleculeImageCarousel :entries="entries" />
        </div>
        <div class="pt-10">
          <h4 v-if="label" class="mb-4 text-2xl font-bold leading-6 uppercase">{{ label }}</h4>
          <div v-if="description" class="prose prose--app mb-8" v-html="description" />
          <AtomButton v-if="buttonLabel && url" button-type="primary" :url="url" :full-width="false">
            <div class="flex place-items-center">
              <div class="flex mr-4">{{ buttonLabel }}</div>
              <AtomIconArrowRight class="flex w-5 h-5 text-black" />
            </div>
          </AtomButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string
  description?: string
  url?: string
  title?: string
  buttonLabel?: string
  entries: any[] // Consider using a more specific type if possible
}

defineProps<Props>()
</script>
